import { render, staticRenderFns } from "./auditDialog.vue?vue&type=template&id=04fabca8&scoped=true"
import script from "./auditDialog.vue?vue&type=script&lang=js"
export * from "./auditDialog.vue?vue&type=script&lang=js"
import style0 from "./auditDialog.vue?vue&type=style&index=0&id=04fabca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fabca8",
  null
  
)

export default component.exports